module.exports = __webpack_public_path__ + "img/Hypoxia-PDAC_GSE111672.dc114508.png";